const typeListAlphabeticalSorter = (optionOtherCode = 'other', placeOptionOtherLast = true) => {
    return (a, b) => {
        if (placeOptionOtherLast) {
            if (a?.code === optionOtherCode) {
                return 1;
            }
            if (b?.code === optionOtherCode) {
                return -1;
            }
        }
        return (a?.name ?? '').localeCompare(b?.name ?? '');
    };
};

export default {
    typeListAlphabeticalSorter,
};
